<template>
  <div class="MessageCode">
    <valid-van-field
      class="term"
      v-model="col"
      :label="label"
      center
      :placeholder="placeholder"
      :rules="reg"
      maxlength="6"
      type="number"
    >

      <button
        type="button"
        slot="button"
        id="buttonStyle"
        :disabled="disabled"
        @click="sendcode"
      >
        {{ messageButton }}

      </button>
    </valid-van-field>
    <van-icon
          class="cross"
          v-if="col"
          @click="clickDelete"
          name="cross"
        />
  </div>
</template>

<script>
// @ is an alias to /src
import { Field, Toast } from 'vant';
import ValidHoc from '@/components/valid';

const ValidVanField = ValidHoc(Field);

export default {
  name: 'MessageCode',
  components: {
    ValidVanField,
  },
  data() {
    return {
      disabled: false,
      messageButton: '获取验证码',
      time: 0,
      col: '',
      timeout: '',
    };
  },
  props: [
    'label',
    'model',
    'placeholder',
    'reg',
    'IsInterface',
    'value',
    'params',
    'inputPicVal',
  ],
  watch: {
    col: {
      // eslint-disable-next-line no-unused-vars
      handler(value, oldVal) {
        if (oldVal === undefined) {
          this.col = this.value;
        }
        this.$emit('input', value);
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(newVal) {
        this.col = newVal;
        this.$emit('input', newVal);
      },
      immediate: true,
    },
  },
  methods: {
    clickDelete() {
      this.col = '';
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        // eslint-disable-next-line no-plusplus
        this.time--;
        this.messageButton = `(${this.time}s)后重试`;
        this.timeout = setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.messageButton = '获取验证码';
        this.disabled = false;
        clearTimeout(this.timeout);
      }
    },
    sendcode() {
      const paramsObj = JSON.parse(JSON.stringify(this.params));
      paramsObj.code = this.inputPicVal;
      console.log(paramsObj.method);
      this.$api.PublicPage[paramsObj.method](paramsObj)
        .then((res) => {
          if (!res.success) {
            Toast({
              message: res.returnMessage,
              forbidClick: true, // 背景不可点击
            });
            this.disabled = false;
          } else {
            this.time = 60;
            this.timer();
          }
        })
        .catch((e) => {
          console.log(e);
          this.disabled = false;
        });
    },
  },
};
</script>
<style scoped>
 >>> .van-field__label{
  color: #1c2438;
  margin-right: 4px;
}
>>> .van-field__body input::placeholder {
  color: #767676;
}
.cross {
  position: absolute;
  top: 13px;
  right: 100px;
  color: #9e9fa0;
}
.bgColor {
  background: #f8f8f9;
}
.van-button--small {
  min-width: 60px;
  height: 30px;
  padding: 0 8px;
  color: #ff6538;
  font-size: 12px;
  line-height: 28px;
  background-color: #fff;
}

.buttonDe {
  margin: 0;
  color: #ccc;
  font-size: 14px;
  outline: none;
}
#buttonStyle {
  margin: 0;
  padding: 0;
  color: #ff6538;
  font-size: 14px;
  background: #fff;
  border: 1px solid transparent;
  outline: none;
  position: absolute;
  top: -2px;
  right: 0;
}
.MessageCode {
  position: relative;
}
.term::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}

</style>
